import axios from 'axios'
import Vue from 'vue'
import store from '../store/index'
import { baseURL } from '../../env'

axios.defaults.baseURL = baseURL
axios.interceptors.request.use(function (config) {
  console.log('inside axios.interceptors.request.use', store.getters)
  const token = store.getters['login/GET_TOKEN']
  config.headers.Authorization = `Bearer ${token}`

  return config
})

Vue.prototype.$axios = axios
export default axios
